/*
 * File: index.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:54 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 1, 2025 at 1:07 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Utilities
import { api } from '../api';

// Constants
const { PARSE_MOUNT } = process.env;


/**
 * Services
 */

export const getCurrentUser = () => api.post(`${PARSE_MOUNT}/functions/getCurrentUser`);

export const getOnlineMembers = () => api.post(`${PARSE_MOUNT}/functions/getOnlineMembers`);

export const validateContributorAccess = ({ aControl, bControl } = {}) => api.post(`${PARSE_MOUNT}/functions/validateContributorAccess`, { a_control: aControl, b_control: bControl });

export const handleContributorActions = ({
	aControl,
	bControl,
	actions,
	email,
	tags
} = {}) => api.post(`${PARSE_MOUNT}/functions/handleContributorActions`, {
	a_control: aControl,
	b_control: bControl,
	actions,
	email,
	tags
});
